import { UploadAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import { IUploadOrderFileDTO, TPresignedFileResponse, IUploadCommonFileDTO } from '@/models/uploads.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { UPLOADS_SLICE_NAME } from './models';

export const uploadOrderFile = createAsyncThunk<
  TPresignedFileResponse,
  IUploadOrderFileDTO,
  { serializedErrorType: IApiError }
>(
  `${UPLOADS_SLICE_NAME}/uploadOrderFile`,
  async (data) => {
    return UploadAPI.uploadOrderFile(data);
  },
  { serializeError: formatApiError },
);

export const uploadCommonFile = createAsyncThunk<
  TPresignedFileResponse,
  IUploadCommonFileDTO,
  { serializedErrorType: IApiError }
>(
  `${UPLOADS_SLICE_NAME}/uploadCommonFile`,
  async (data) => {
    return UploadAPI.uploadCommonFile(data);
  },
  { serializeError: formatApiError },
);
